// src/services/api.js
import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptador de Requisições
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Funções estruturadas para chamadas específicas
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject({
        response: {
          data: {
            message: "Por favor, verifique sua conexão à internet.",
          },
        },
      });
    }
    if (error.response.status === 401) {
      return Promise.reject({
        response: {
          data: {
            message: "Usuário não autorizado.",
          },
        },
      });
    }
    return Promise.reject(error);
  }
);

export default api;
